import React, { useEffect, useState, useRef } from "react";
import "./HivePort.css";
import logocubg from "../../assets/logos/logocubg.png";
import discord_logo from "../../assets/hiveport_page/discord_logo.png";
import behance_logo from "../../assets/hiveport_page/behance_logo.png";
import instagram_logo from "../../assets/hiveport_page/instagram_logo.png";
import youtube_logo from "../../assets/hiveport_page/youtube_logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import union2 from "../../assets/ourteampage/union2.png";
import Projects from "../contexts_config/Projects";

import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";

const HivePort = ({ onProjectClick }) => {
  const brandingProjectIds = [
    "crx-branding",
    "felix-branding",
    "gamebattle-branding",
    "hive-branding",
    "mauris-branding",
    "rhq-branding",
    "rhqcs-branding",
    "ug-branding",
  ];

  const isBrandingProject = (project) =>
    brandingProjectIds.includes(project.id);

  const [selectedFilter, setSelectedFilter] = useState("all");
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);
  const filteredProjects =
    selectedFilter === "branding"
      ? Projects.filter(isBrandingProject)
      : selectedFilter === "web"
        ? Projects.filter((project) => !isBrandingProject(project))
        : Projects;

  const currentProject =
    filteredProjects[currentProjectIndex] || filteredProjects[0] || Projects[0];

  const hiveportRef = useRef(null);
  const topBarRef = useRef(null);
  const hiveDetailsRef = useRef(null);
  const centerTopbarRef = useRef(null);
  const rightTopbarRef = useRef(null);
  const midleRef = useRef(null);
  const unionsRef = useRef(null);

  useEffect(() => {
    setCurrentProjectIndex(0);
  }, [selectedFilter]);

  const nextProject = () => {
    setCurrentProjectIndex((prevIndex) =>
      prevIndex === filteredProjects.length - 1 ? 0 : prevIndex + 1,
    );
  };

  const prevProject = () => {
    setCurrentProjectIndex((prevIndex) =>
      prevIndex === 0 ? filteredProjects.length - 1 : prevIndex - 1,
    );
  };

  const handleImageClick = () => {
    if (onProjectClick) {
      onProjectClick(currentProject.id);
    }
  };

  const generateShortDescription = (project) => {
    const items = [
      ...project.types,
      ...project.tools.split(", "),
      "Custom Design",
      "Professional Work",
      "Client Satisfaction",
      "Modern Approach",
    ];
    return items.slice(0, 6); // Take first 6 items
  };

  return (
    <div className="hiveport_page" id="hivePort" ref={hiveportRef}>
      <div className="cont_hiveport">
        <div className="top_bar_hiveport" ref={topBarRef}>
          <div className="hive_details_port" ref={hiveDetailsRef}>
            <img src={logocubg} alt="HiveTeam portfolio badge" />
            <div className="hivecuchenar">
              <h1>HiveTeam Portfolio</h1>
              <div className="linie_daia"></div>
            </div>
            <h2>PROJECTS</h2>
          </div>

          <div className="center_hive_topbar" ref={centerTopbarRef}>
            <div className="linie1"></div>
            <h1>{currentProject.title}</h1>
            <div className="linie2"></div>
          </div>

          <div className="right_hive_topbar" ref={rightTopbarRef}>
            <div className="social_media">
              <img src={discord_logo} alt="" />
            </div>
            <div className="social_media">
              <img src={behance_logo} alt="" />
            </div>
            <div className="social_media">
              <img src={instagram_logo} alt="" />
            </div>
            <div className="social_media">
              <img src={youtube_logo} alt="" />
            </div>
          </div>
        </div>
        <div className="midle_hiveport" ref={midleRef}>
          <div className="left_midle_hiveport">
            <img
              src={currentProject.headerImage}
              alt={`${currentProject.title} project preview`}
              onClick={handleImageClick}
              role="button"
              tabIndex={0}
              aria-label={`Open ${currentProject.title} project details`}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleImageClick();
                }
              }}
            />
            <div className="bottom_left_midle">
              <button className="go_left_midle" onClick={prevProject}>
                <FontAwesomeIcon
                  className="icon_nav_port"
                  icon={faChevronLeft}
                />
              </button>
              <div className="click_to_interact">
                <div className="cont">
                  <svg
                    width="20"
                    height="30"
                    viewBox="0 0 20 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0024 6.25195C9.67072 6.25195 9.35268 6.38369 9.11819 6.61819C8.88369 6.85268 8.75195 7.17072 8.75195 7.50235V12.5039C8.75195 12.8356 8.88369 13.1536 9.11819 13.3881C9.35268 13.6226 9.67072 13.7543 10.0024 13.7543C10.334 13.7543 10.652 13.6226 10.8865 13.3881C11.121 13.1536 11.2527 12.8356 11.2527 12.5039V7.50235C11.2527 7.17072 11.121 6.85268 10.8865 6.61819C10.652 6.38369 10.334 6.25195 10.0024 6.25195Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M-0.000976562 10.0032C-0.000976562 7.35017 1.05293 4.80582 2.92889 2.92986C4.80485 1.0539 7.34919 0 10.0022 0C12.6552 0 15.1996 1.0539 17.0755 2.92986C18.9515 4.80582 20.0054 7.35017 20.0054 10.0032V20.0064C20.0054 22.6594 18.9515 25.2037 17.0755 27.0797C15.1996 28.9556 12.6552 30.0095 10.0022 30.0095C7.34919 30.0095 4.80485 28.9556 2.92889 27.0797C1.05293 25.2037 -0.000976562 22.6594 -0.000976562 20.0064V10.0032ZM17.5046 10.0032V20.0064C17.5046 21.9961 16.7142 23.9044 15.3072 25.3113C13.9002 26.7183 11.992 27.5087 10.0022 27.5087C8.01245 27.5087 6.10419 26.7183 4.69722 25.3113C3.29025 23.9044 2.49982 21.9961 2.49982 20.0064V10.0032C2.49982 8.01342 3.29025 6.10516 4.69722 4.69819C6.10419 3.29122 8.01245 2.5008 10.0022 2.5008C11.992 2.5008 13.9002 3.29122 15.3072 4.69819C16.7142 6.10516 17.5046 8.01342 17.5046 10.0032V10.0032Z"
                      fill="white"
                    />
                  </svg>

                  <p>Click on photo to interact</p>
                </div>
              </div>
              <button className="go_right_midle" onClick={nextProject}>
                <FontAwesomeIcon
                  className="icon_nav_port"
                  icon={faChevronRight}
                />
              </button>
            </div>
          </div>
          <div className="right_midle_section">
            <div className="project_filters">
              <button
                className={`filter_button ${selectedFilter === "all" ? "active" : ""}`}
                onClick={() => setSelectedFilter("all")}
              >
                ALL
              </button>
              <button
                className={`filter_button ${selectedFilter === "branding" ? "active" : ""}`}
                onClick={() => setSelectedFilter("branding")}
              >
                BRANDING
              </button>
              <button
                className={`filter_button ${selectedFilter === "web" ? "active" : ""}`}
                onClick={() => setSelectedFilter("web")}
              >
                WEB
              </button>
            </div>

            <div className="right_midle_hiveport">
              <h1>
                {" "}
                <div className="linie"></div> Description{" "}
                <div className="linie"></div>
              </h1>
              <div className="short_description_list">
                {generateShortDescription(currentProject).map((item, index) => (
                  <div key={index} className="description_item">
                    • {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <img className="unions" src={union2} alt="Union 2" ref={unionsRef} />
      </div>
    </div>
  );
};

export default HivePort;
